import { ApplicationRef, inject, Injectable, Injector, Type, DOCUMENT } from '@angular/core'

import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal'

declare const window: any

@Injectable()
export class DomService {
  protected document = inject(DOCUMENT)

  constructor (
    protected appRef: ApplicationRef,
    protected injector: Injector,
  ) {}

  inject (component: Type<any>) {
    new DomPortalOutlet(this.document.body, this.appRef, this.injector)
      .attach(new ComponentPortal(component))
  }
}